<template>
  <post-detail :post="post" :comments="comments" :postId="postId"></post-detail>
</template>

<script>
import { getDatabase, ref, onValue, push, child } from 'firebase/database';
import PostDetail from "@/components/PostDetail";

export default {
  components: {PostDetail},
  data() {
    return {
      post: {
        title: '',
        body: '',
        author: ''
      },
      comments: [],
      newComment: ''
    };
  },
  computed: {
    postId() {
      return this.$route.params.id;
    }
  },
  methods: {
    fetchPost() {
      const dbRef = ref(getDatabase());
      onValue(child(dbRef, `posts/${this.postId}`), (snapshot) => {
        if (snapshot.exists()) {
          this.post = snapshot.val();
        } else {
          console.log("No data available");
        }
      });
    },
    fetchComments() {
      const commentsRef = ref(getDatabase(), `post-comments/${this.postId}`);
      onValue(commentsRef, (snapshot) => {
        const commentsArray = [];
        snapshot.forEach((childSnapshot) => {
          commentsArray.push(childSnapshot.val());
        });
        this.comments = commentsArray;
      });
    },
    submitComment() {
      const currentUser = this.$store.getters.currentUser;
      if (!currentUser) {
        alert('Bitte loggen Sie sich ein, um einen Kommentar zu posten.');
        return;
      }

      const commentsRef = ref(getDatabase(), `post-comments/${this.postId}`);
      push(commentsRef, {
        text: this.newComment,
        author: currentUser.displayName || currentUser.email,
        uid: currentUser.uid
      });
      this.newComment = '';
    }
  },
  created() {
    this.fetchPost();
    this.fetchComments();
  }
}
</script>

<style scoped>
/* Fügen Sie hier Ihr CSS hinzu, um das Design anzupassen */
</style>
